// src/Auth/AuthProvider.tsx
import React, { Component } from "react";
import AbpnSpinner from "../Shared/Components/AbpnSpinner";
import AuthService, { IAuthService } from "../Services/Auth/AuthService";

export const AuthContext = React.createContext<IAuthService>(null as any);
export const AuthConsumer = AuthContext.Consumer;

type State = { isReady: boolean; initError?: string | null };

export class AuthProvider extends Component<React.PropsWithChildren<{}>, State> {
    private authService: IAuthService;

    constructor(props: {}) {
        super(props);
        this.state = { isReady: false, initError: null };
        // Default export is a *class* so this is fine:
        this.authService = new AuthService();
    }

    async componentDidMount() {
        try {
            await this.authService.initialize();
            this.setState({ isReady: true });
        } catch (e: any) {
            console.error("Auth initialization failed:", e);
            this.setState({
                isReady: false,
                initError: e?.message ?? "Auth initialization failed",
            });
        }
    }

    render() {
        if (!this.state.isReady) {
            if (this.state.initError) {
                return (
                    <div className="p-3 text-danger">
                        {this.state.initError}
                    </div>
                );
            }
            return <AbpnSpinner />;
        }

        return (
            <AuthContext.Provider value={this.authService}>
                {this.props.children}
            </AuthContext.Provider>
        );
    }
}

export default AuthProvider;
